import styled from '@emotion/styled';

export const InfoTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  tr {
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
    
    &:last-child {
      border-bottom: none;
    }
  }

  td {
    padding: ${({ theme }) => theme.spacing(1.5)} 0;
    vertical-align: top;
    
    &.field-label {
      font-weight: 600;
      font-size: 14px;
      color: ${({ theme }) => theme.palette.text.secondary};
      width: 140px;
      min-width: 140px;
    }
    
    &.field-value {
      padding-left: ${({ theme }) => theme.spacing(3)};
      font-size: 14px;
      color: ${({ theme }) => theme.palette.text.primary};
      word-break: break-word;
      
      a {
        text-decoration: none;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;
